<template>
  <div class="pageOne">
    <scroll ref="scroll" @scrollToEnd="getData">
        <van-nav-bar
         class="jinkf"
        :left-text="$t('other.a1279')"
        left-arrow
        @click-left="onClickLeft"
        />
      <div class="ijgn">
          <div class="oknlkg"><img style="width:100%" :src="imgUrl" /></div>
          <div class="bpmng">{{getCountry(country)}}{{$t('other.a1712')}}</div>
      </div>
      <GoodList :country="country" :showLoading="false" :orderList="orderList"></GoodList>
    </scroll>
      
  </div>
</template>

<script>
import GoodList from '../components/goodlist'
import utils from '../../../utils/utils'
import api from '../../../api/api'
import scroll from '../componentsbase/scroll'
export default {
data(){
return{
    country:null,
    orderList:[],
    dataParams:{
        categoryIds:[],
        name:null,
        country:null,
        offset:10,
        page:0,
        sortType:0,
        userId:null
    },
    imgUrl:null,
    areaList:[{
        country:'TH',
        label:this.$t('chat.Thailand'),
        imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/19eab6fe794e4afb9fa1926be6d69fd1.png'
    },{
        country:'MY',
        label:this.$t('h5.DSX_index_my'),
        imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/12ef3ca7a7504a46a94bf6cc9c90afdd.png'
    },{
        country:'PH',
        label:this.$t('h5.DSX_index_ph'),
        imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/33c5ac8214fe450fa3a9f79792d5cba7.png'
    },{
        country:'TW',
        label:this.$t('h5.DSX_index_tw'),
        imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/f384543fc28841409f5a75346b4e9447.png'
    },{
        country:'ID',
        label:this.$t('chat.Indonesia'),
        imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/245a7cf4081347628838b042479e8c3a.png'
    },{
        country:'VN',
        label:this.$t('h5.DSX_index_vn'),
        imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/36312c8bb5064d5c9e8d21eda8ea23e6.png'
    },{
        country:'BZ',
        label:this.$t('h5.DSX_index_bz'),
        imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/c71468db1f744cf585a0161dbb2cfda7.png'
    },{
        country:'CN',
        label:this.$t('h5.DSX_index_cn'),
        imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/664e760fce604256a502794ffa85df71.jpg'
    }],
    
}
},
components:{
    GoodList,
    scroll
},
created(){
    this.country=this.$route.query.country
    this.dataParams.country=this.country
    this.showLoading=false
    this.imgUrl=this.areaList.find(item => item.country == this.country).imgUrl
    this.init()
},
methods:{
    getCountry(code){
        return utils.getCountryName(code)
    },
    init(){
    this.userInfo=JSON.parse(localStorage.getItem('userInfo')) 
    // this.dataParams.country=this.country
    let userInfo=localStorage.getItem('userInfo')
    this.userId= userInfo ? JSON.parse(userInfo).userId : null
    this.dataParams.agencyUserId=this.userId
    this.getDataParams()
  },

  getDataParams(){
       if(this.$route.query.invitationCode){
           newOrders
           .getUserInviteeByCode({
               code:this.$route.query.invitationCode
           })
           .then(res => {
               if(res.code == 200) {
                   this.dataParams.userId=res.data.userId
                   
                    this.getData()
               }else{
                   
               }
           })
       }else{
           this.getData()
       }
       
   },
   getData(){
    this.showLoading=true
        api
        .getPublicStoreItem(this.dataParams)
        .then(res => {
        if(res.code === 200 ){
        console.log('ddpp',res.data)
        let list=res.data.groups
        console.log(list)
        let falg=res.data.groups.length%2 == 0 ? true : false
        for (let index = 0; index < list.length; index += 2) {
            console.log(index)
        console.log(list[index].groupId)
            list[index].minGrossProfitRate=list[index].minGrossProfitRate < 0 ? 0 : list[index].minGrossProfitRate
            this.orderList.push([
                list[index],
                list[index+1]
            ])
        
            
        }
        if(!falg){
            let num =this.orderList.length-1
            this.orderList[num].splice(1,1)
        }

        if(this.dataParams.page < res.data.count-1){
          this.dataParams.page+=this.dataParams.offset
          console.log(this.dataParams.page)
        }

        console.log('orderList',this.orderList)
        this.$nextTick(() => {
          this.$refs.scroll.refresh()
        })
        


      
  
        }else{
        this.$message.warning(res.msg)
        }
        })
    },
    onClickLeft(){
        
        this.$router.push({
            path:'/mh5/index',
            query:{
                invitationCode:this.$route.query.invitationCode
            }
        })
        
    },
}
}

</script>
<style lang="scss" scoped>

.pageOne{
    background-color: #eee;
    padding-top: 48px;

    .jinkf{
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
    }
    

    .ijgn{
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 0.5rem 1rem;
        background-color: wheat;



        .oknlkg{
            width:2rem;
            height: 2rem;
            overflow: hidden;

        }


        .bpmng{
            padding-left:20px
        }
        
        

        
    }
}
</style>